<script>
import List from '../../baseComponents/list'

import { ERROR, isThemeDateKey } from '../../variables'

export default {
	extends: List,
	props: ['navigationVariables', 'valueType', 'date'],
	data() {
		return {
			defaultSort: "-Date d'inscription",
			rowClick: (item) => {
				this.$router.push({ name: 'UserDetail', params: { botId: this.$route.params.botId, userId: item._id } })
			},
			items: [],
			internActions: [
				{
					name: 'Exporter',
					function: async (filterString, page) => {
						try {
							let url = this.url.replace('navigations', 'navigations\\export') + filterString
							// TODO there are too much naviation variable in some bot to delete the pagination...
							url +=
								(url.includes('?') ? '&' : '?') +
								'limit=' +
								this.pagination.rowsPerPage +
								'&page=' +
								this.pagination.page

							if (this.pagination.sortBy) {
								let sortItem = this.items.find((el) => el.header === this.pagination.sortBy)
								if (sortItem) {
									let sortFilter = sortItem.sort ? sortItem.sort : sortItem.header
									url +=
										(url.includes('?') ? '&' : '?') + 'sort=' + (this.pagination.descending ? '-' : '') + sortFilter
								}
							}

							const { data } = await this.axios.get(url)
							let csvContent = 'data:text/csv;charset=utf-8,' + data
							let encodedUri = encodeURI(csvContent)

							const link = document.createElement('a')
							link.setAttribute('href', encodedUri)
							link.setAttribute('download', 'export.csv')
							link.click()
						} catch (err) {
							console.log(err)
							this.$store.dispatch(ERROR, err)
						}
					},
				},
			],
		}
	},
	watch: {
		navigationVariables() {
			this.initItems()
		},
	},
	mounted() {
		this.initItems()
	},
	methods: {
		getValue(variable) {
			let navigateAt = variable.navigateAt

			let start, end
			if (this.date.from) {
				start = new Date(this.date.from)
			}
			if (this.date.to) {
				end = new Date(this.date.to)
				end.setDate(end.getDate() + 1)
			}
			if (start || end) {
				navigateAt = navigateAt
					? navigateAt.filter((navigate) => {
							let begin = new Date(navigate.begin)
							if (start && end) {
								return begin.getTime() > start.getTime() && begin.getTime() < end.getTime()
							} else if (start) {
								return begin.getTime() > start.getTime()
							} else if (end) {
								return begin.getTime() < end.getTime()
							}
							return true
					  })
					: []
			}

			if (this.valueType === 'Nombre de passage') {
				return navigateAt.length
			}

			if (this.valueType === 'dernier passage') {
				if (navigateAt.length === 0) {
					return ''
				} else {
					let lastNavigateBegin = new Date(navigateAt[0].begin)
					for (let i = 0; i < navigateAt.length; i++) {
						if (new Date(navigateAt[i].begin).getTime() > lastNavigateBegin.getTime()) {
							lastNavigateBegin = new Date(navigateAt[i].begin)
						}
					}
					return this.$options.filters.formatDate(lastNavigateBegin)
				}
			}

			if (this.valueType === 'temps total') {
				if (navigateAt.length === 0) {
					return ''
				} else {
					let navigateTime = navigateAt.reduce((acc, el) => {
						if (el.end) {
							return acc + new Date(el.end).getTime() - new Date(el.begin).getTime()
						}
						return acc
					}, 0)

					let totalSeconde = Math.round(navigateTime / 1000)
					if (totalSeconde > 60) {
						return Math.floor(Math.min(totalSeconde / 60)) + ' min ' + (totalSeconde % 60) + 's'
					} else {
						return totalSeconde + 's'
					}
				}
			}

			return variable.value
		},
		initItems() {
			this.items = [
				{
					header: "Date d'inscription",
					value: (item) => this.$options.filters.formatDate(item.createdAt),
					sort: 'createdAt',
				},
				{
					header: 'Date thématique',
					value: (item) => {
						let dateVariable = item.userVariables.find((el) => isThemeDateKey(el.key) && el.value)
						if (dateVariable) {
							return this.$options.filters.formatDate(dateVariable.value)
						}
						return ''
					},
				},
				{
					header: 'Premiere connexion',
					value: (item) => {
						for (let i = 0; i < item.navigationVariables.length; i++) {
							let navigateAt = item.navigationVariables[i].navigateAt
							if (navigateAt && navigateAt.length > 0) {
								return this.$options.filters.formatDate(navigateAt[0].begin)
							}
						}
					},
				},
				{
					header: 'Utilisateur',
					value: (item) => item.botNationId,
					sort: 'botNationId',
					filter: { name: 'botNationId' },
				},
				...this.navigationVariables.reduce((acc, el) => {
					acc.push({
						header: el.name,
						filter: false,
						sort: false,
						value: (item) => {
							for (let i = 0; i < item.navigationVariables.length; i++) {
								if (el._id === item.navigationVariables[i]._id) {
									return this.getValue(item.navigationVariables[i])
								}
							}
							return ''
						},
					})
					return acc
				}, []),
			]
			this.$forceUpdate()
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.user.list.vue